import { Button, CircularProgress, Snackbar } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import { Alert } from '@mui/material';
import { observer } from "../../../utils/observer";
import { api, apiUrls } from "../../../utils/api";
import { ProjectAssistantHub, ProjectAssistantHubLines } from "../../../utils/signalR/projectAssistantHub";
import { ApiClientContext } from '../../../components/ApiProvider';

const syncProject = async (MainProjectID, connectionId, apiClient) => {
  await apiClient.post(apiUrls.SyncProject, undefined, {
    MainProjectID,
  });
};

class SyncProjectComponent extends React.PureComponent {
  static contextType = ApiClientContext;
  state = {
    open: false,
    progress: 0,
    message: null,
    finished: false,
    started: false,
  };
  constructor(props) {
    super(props);
    this.onMessage = this.onMessage.bind(this);
  }

  async componentDidMount() {
    this.projectAssistantHub = new ProjectAssistantHub(await this.context.getAccessToken());
    this.projectAssistantHub.on(ProjectAssistantHubLines.projectSyncMessage, this.onMessage);
    this.unsubscribeSync = observer.subscribe("SyncProject", this.onSync);
  }

  componentWillUnmount() {
    this.projectAssistantHub.off(ProjectAssistantHubLines.projectSyncMessage, this.onMessage);
    this.unsubscribeSync && this.unsubscribeSync();
  }
  onSync = async () => {
    this.setState({
      open: true,
      message: this.props.t("project.syncStarted"),
      started: true,
      finished: false,
    });
    await syncProject(this.props.mainProjectId, this.projectAssistantHub.connectionId, this.context);
  };

  onMessage(progress, message) {
    this.setState({
      progress,
      message,
      finished: progress === 100,
      started: progress !== 100,
    });
    if (progress === 100) {
      observer.trigger("SyncProjectFinished");
    }
  }
  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  onClick = async () => {
    this.setState({
      open: true,
      message: this.props.t("project.syncStarted"),
      started: true,
      finished: false,
    });
    pendo.track("Sync current project", {
      projectId: this.props.mainProjectId
    });
    await syncProject(this.props.mainProjectId, this.projectAssistantHub.connectionId, this.context);
  };
  render() {
    const { open, message, started, finished } = this.state;
    const icon = started && !finished ? <CircularProgress size={20} /> : undefined;
    const alert = (
      <Alert icon={icon} onClose={this.handleClose} severity="info" elevation={12}>
        {message}
        {finished && (
          <>
            &nbsp; &nbsp; &nbsp;
            <Button size="small" variant="contained" color="secondary" onClick={this.props.onRefreshProject} data-testid="refresh-project-button">
              refresh
            </Button>
          </>
        )}
      </Alert>
    );
    return (
      <>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={open}
          autoHideDuration={0}
          children={alert}
          data-testid="sync-finished-popup"
        />
      </>
    );
  }
}
export const SyncProject = withTranslation()(SyncProjectComponent);
